import React, { Component } from "react";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import FileSaver from "file-saver";
import styled, { createGlobalStyle } from "styled-components";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";
import get from "lodash/get";

import { initialStateData, fontMap } from "../../helpers/constant";
import EditorMenu from "../EditorMenu/EditorMenu";
import StaticTemplate from "../StaticTemplate/StaticTemplate";
import backBtn from "../../assets/back.svg";
import NewStaticTemplate from "../NewTemplate/NewTemplate";

class ResumeBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = { ...initialStateData, isPopupVisible: false };
  }

  setNormalValueToState = (name, value) => {
    if (name === "font") {
      this.setState({
        [name]: value,
        fontName: this.calculateFontName(value),
      });
    } else {
      this.setState({
        [name]: value,
      });
    }
  };

  setArrayValueToState = (name, index, value) => {
    let array = this.state[name];
    array[index] = value;
    array = array.filter(String);
    this.setState({
      [name]: array,
    });
    this.forceUpdate();
  };

  setObjectValueToState = (name, child, value) => {
    let obj = this.state[name];
    obj[child] = value;
    this.setState({
      [name]: obj,
    });
    this.forceUpdate();
  };

  setArrayOfObjectToState = (name, index, childName, value) => {
    let array = this.state[name];
    let selectedItem = array[index];
    selectedItem[childName] = value;
    this.setState({
      [name]: array,
    });
    this.forceUpdate();
  };

  addNewArrayValue = (name) => {
    let array = this.state[name];
    array.push("EditMe");
    this.setState({
      [name]: array,
    });
    this.forceUpdate();
  };

  addNewArrayOfObject = (name, val) => {
    let array = this.state[name];
    array.push(val);
    this.setState({
      [name]: array,
    });
    this.forceUpdate();
  };

  deleteFromArrayOfObject = (name, index) => {
    let array = this.state[name];
    delete array[index];
    this.setState({
      [name]: array,
    });
    this.forceUpdate();
  };

  deleteSingleItem = (name) => {
    this.setState({ [name]: undefined });
  };

  saveData = () => {
    const stateData = this.state;
    const data = this.clean(stateData);

    let blob = new Blob([JSON.stringify(data)], {
      type: "application/txt;charset=utf-8",
    });
    let url = URL.createObjectURL(blob);
    let elem = document.createElement("a");
    elem.href = url;
    const name = this.state.name + "_" + this.state.surname;
    elem.download = name + ".resume";
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);
  };

  loadData = (e) => {
    const { files } = e.target;
    if (files[0]) {
      var reader = new FileReader();
      reader.readAsText(files[0], "UTF-8");
      reader.onload = (evt) => {
        const result = JSON.parse(evt.target.result);
        this.setState(result);
      };
      reader.onerror = function (evt) {
        console.log("Error Loading file");
      };
    } else {
      console.log("No file uploaded");
    }
  };

  clean = (obj) => {
    for (var propName in obj) {
      if (
        obj[propName] === null ||
        obj[propName] === undefined ||
        obj[propName] === ""
      ) {
        delete obj[propName];
      } else if (Array.isArray(obj[propName])) {
        obj[propName] = obj[propName].filter(
          (value) => Object.keys(value).length !== 0 && String
        );
        if (obj[propName].length > 0) {
          for (let i = 0; i <= obj[propName].length; i++) {
            this.clean(obj[propName][i]);
          }
        }
      }
    }
    return obj;
  };

  generateResume = () => {
    this.setState({ loading: true });
    let data = this.state;
    data = this.clean(data);
    const url =
      get(this.props.location.query, "template", "creativo") === "fantastico"
        ? `${process.env.REACT_APP_BASE_URL}/generate-resume/v1`
        : `${process.env.REACT_APP_BASE_URL}/generate-resume`;
    axios
      .post(url, data, {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "*",
        },
      })
      .then((response) => {
        var blob = new Blob([response.data], {
          type: response.headers["Content-Type"],
        });
        const name = this.state.name + "_" + this.state.surname;

        const fileName = name + ".pdf";
        FileSaver.saveAs(blob, fileName);
        this.setState({ loading: false });
      })
      .catch((e) => {
        this.setState({ loading: false });
        console.log("Error Occured ", e);
      });
  };

  calculateFontName = (name) => {
    return Object.keys(fontMap).find((key) => fontMap[key] === name);
  };

  setVisiblity = (value) => {
    this.setState({
      isPopupVisible: value === undefined ? !this.state.isPopupVisible : value,
    });
  };

  render() {
    const { loading } = this.state;
    if (loading === true) {
      return (
        <div className="spinner">
          <ClipLoader size={50} color={"#123abc"} loading={true} />
        </div>
      );
    }
    return (
      <div onBlur={() => this.setVisiblity(false)}>
        <EditorMenuWrapper>
          <EditorMenu
            color={this.state.color}
            showPicker={this.state.isPopupVisible}
            setVisiblity={this.setVisiblity}
            saveData={this.saveData}
            loadData={this.loadData}
            setColor={this.setNormalValueToState}
            changeHandler={this.setNormalValueToState}
          />
          <button onClick={this.generateResume} className="glow-on-hover">
            Generate Resume
          </button>
        </EditorMenuWrapper>
        <h2 color={this.state.color} className="marTop-10 marBottom-10">
          {" "}
          Edit The Template With Live Editor (click on items below)
        </h2>
        <GlobalStyle font={this.state.fontName} size={this.state.fontSize} />
        <BackBtn
          src={backBtn}
          onClick={() => this.props.history.push("/")}
          alt="backBtn"
        />
        <Helmet>
          <meta charSet="utf-8" />
          <meta
            name="viewport"
            content="width=device-width,height=device-height, initial-scale=0.5, maximum-scale=2, minimum-scale=0.25, user-scalable=yes"
          />
        </Helmet>
        {get(this.props.location.query, "template", "creativo") ===
        "creativo" ? (
          <StaticTemplate
            state={this.state}
            setNormalValueToState={this.setNormalValueToState}
            setArrayValueToState={this.setArrayValueToState}
            addNewArrayValue={this.addNewArrayValue}
            setObjectValueToState={this.setObjectValueToState}
            deleteFromArrayOfObject={this.deleteFromArrayOfObject}
            deleteSingleItem={this.deleteSingleItem}
            setArrayOfObjectToState={this.setArrayOfObjectToState}
            addNewArrayOfObject={this.addNewArrayOfObject}
          />
        ) : (
          <NewStaticTemplate
            state={this.state}
            setNormalValueToState={this.setNormalValueToState}
            setArrayValueToState={this.setArrayValueToState}
            addNewArrayValue={this.addNewArrayValue}
            setObjectValueToState={this.setObjectValueToState}
            deleteFromArrayOfObject={this.deleteFromArrayOfObject}
            deleteSingleItem={this.deleteSingleItem}
            setArrayOfObjectToState={this.setArrayOfObjectToState}
            addNewArrayOfObject={this.addNewArrayOfObject}
          />
        )}
      </div>
    );
  }
}

const GlobalStyle = createGlobalStyle`
  * {
    font-size:${(props) => props.size};
    font-family:${(props) => `${props.font} !important`};
    } 
`;

const BackBtn = styled.img`
  position: absolute;
  top: 20px;
  left: 30px;
  height: 30px;
  transition: all 0.2s ease-in-out;
  &:hover {
    transform: scale(1.4);
  }
`;
const EditorMenuWrapper = styled.div`
  display: flex;
  align-items: center;
  & > button {
    margin: auto 20px 47px 20px;
  }
`;

export default withRouter(ResumeBuilder);
